import { AllNotificationsPage } from "./allNotifications";

export const AllNotifications = AllNotificationsPage;
